import { Team } from "@brg/api";
import { useProfile } from "@brg/auth";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { FC, useMemo } from "react";
import { ChannelDefault } from "./ChannelDefault";
import ChannelsDropdown from "shared/components/ChannelsInfo/components/ChannelsDropdown";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { LayoutConst } from "core";

export const ChannelNavigator: FC<{ channel: Team }> = ({ channel}) => {
    const profile = useProfile();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const { isChannel } = isTeamChannel(channel?.moderationType ?? ModerationType.Default)

      const shouldVisibleDefaultChannel = useMemo(() => {
        return !!(channel?.ownersIDs?.includes(profile?.accountId ?? '') || channel?.channelCommentWhiteListIds?.includes(profile?.accountId ?? ''))
      } , [channel, profile])

      if (!channel || !isChannel) {
        return null;
      }

      if (shouldVisibleDefaultChannel) {
        return (
            <FlexBox style={{ placeItems: 'baseline', ...(isMobile && { flexFlow: 'column'}) }} gx={24} gxMobile={isMobile ? 1 : 24}>
                <ChannelDefault channel={channel}/>
                <ChannelsDropdown channel={channel}/>
            </FlexBox>
        )
      }

    return <ChannelsDropdown channel={channel}/>
}import { Team } from "@brg/api";
import { useProfile } from "@brg/auth";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { FC, useMemo } from "react";
import { ChannelDefault } from "./ChannelDefault";
import ChannelsDropdown from "shared/components/ChannelsInfo/components/ChannelsDropdown";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { LayoutConst } from "core";

export const ChannelNavigator: FC<{ channel: Team }> = ({ channel}) => {
    const profile = useProfile();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const { isChannel } = isTeamChannel(channel?.moderationType ?? ModerationType.Default)

      const shouldVisibleDefaultChannel = useMemo(() => {
        return !!(channel?.ownersIDs?.includes(profile?.accountId ?? '') || channel?.channelCommentWhiteListIds?.includes(profile?.accountId ?? ''))
      } , [channel, profile])

      if (!channel || !isChannel) {
        return null;
      }

      if (shouldVisibleDefaultChannel) {
        return (
            <FlexBox style={{ placeItems: 'baseline', ...(isMobile && { flexFlow: 'column'}) }} gx={24} gxMobile={isMobile ? 1 : 24}>
                <ChannelDefault channel={channel}/>
                <ChannelsDropdown channel={channel}/>
            </FlexBox>
        )
      }

    return <ChannelsDropdown channel={channel}/>
}